var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      attrs: {
        no: "msdApiLogDialog",
        visible: _vm.innerVisible,
        title: _vm.$t("SystemMaintenance.MsdApiLog"),
        "close-on-click-modal": false,
        width: "1000px"
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        },
        close: _vm.dialogClose
      }
    },
    [
      _c("cargo-ag-grid", {
        attrs: {
          "config-module": "2024032003",
          "grid-options": _vm.gridOptions,
          "grid-params": _vm.gridParams,
          "column-defs": _vm.columnDefs,
          "row-data": _vm.rowData
        },
        on: {
          "update:gridParams": function($event) {
            _vm.gridParams = $event
          },
          "update:grid-params": function($event) {
            _vm.gridParams = $event
          }
        }
      }),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function($event) {
                  return _vm.dialogClose()
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
          ),
          _c("el-button", { on: { click: _vm.dialogClose } }, [
            _vm._v(_vm._s(_vm.$t("common.btn.cancel")))
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }